import { Select, SelectItem, type SelectProps } from '@sapphire-react/core';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { useSapphireMedia } from '../hooks';
import { FormFieldProps } from '../types';
import { applyDataTestIdToChildren } from '../utils';
import styled from 'styled-components';

type Props = Omit<SelectProps<any>, 'name'> & {
  name: string;
  children: ReactNode;
} & FormFieldProps;

export function SelectField(props: Props) {
  const { control, name, defaultValue, children, rules, ...rest } = props;
  const { isExtraSmall, isSmall } = useSapphireMedia();

  return (
    <Wrapper>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || undefined}
        render={({ field: { ref: _ref, ...field }, fieldState: { error } }) => (
          <Select
            {...field}
            {...rest}
            id={field.name}
            value={field.value}
            error={error?.message}
            onChange={(selectedValue) => field.onChange(selectedValue)}
            size={isExtraSmall || isSmall ? 'md' : 'lg'}
            data-test-id={`${name}-select`}
          >
            {applyDataTestIdToChildren(
              children,
              SelectItem,
              name,
              'Option',
              'children',
            )}
          </Select>
        )}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  label {
    display: inline;
  }
`;
